
const locationCityList = [
    {cityId: '1', city: 'Adana', region: 'Akdeniz'},
    {cityId: '2', city: 'Adıyaman', region: 'Güneydoğu Anadolu'},
    {cityId: '3', city: 'Afyonkarahisar', region: 'Ege'},
    {cityId: '4', city: 'Ağrı', region: 'Doğu Anadolu'},
    {cityId: '68', city: 'Aksaray', region: 'İç Anadolu'},
    {cityId: '5', city: 'Amasya', region: 'Karadeniz'},
    {cityId: '6', city: 'Ankara', region: 'İç Anadolu'},
    {cityId: '7', city: 'Antalya', region: 'Akdeniz'},
    {cityId: '75', city: 'Ardahan', region: 'Doğu Anadolu'},
    {cityId: '8', city: 'Artvin', region: 'Karadeniz'},
    {cityId: '9', city: 'Aydın', region: 'Ege'},
    {cityId: '10', city: 'Balıkesir', region: 'Marmara'},
    {cityId: '74', city: 'Bartın', region: 'Karadeniz'},
    {cityId: '72', city: 'Batman', region: 'Güneydoğu Anadolu'},
    {cityId: '69', city: 'Bayburt', region: 'Karadeniz'},
    {cityId: '11', city: 'Bilecik', region: 'Marmara'},
    {cityId: '12', city: 'Bingöl', region: 'Doğu Anadolu'},
    {cityId: '13', city: 'Bitlis', region: 'Doğu Anadolu'},
    {cityId: '14', city: 'Bolu', region: 'Karadeniz'},
    {cityId: '15', city: 'Burdur', region: 'Akdeniz'},
    {cityId: '16', city: 'Bursa', region: 'Marmara'},
    {cityId: '17', city: 'Çanakkale', region: 'Marmara'},
    {cityId: '18', city: 'Çankırı', region: 'İç Anadolu'},
    {cityId: '19', city: 'Çorum', region: 'Karadeniz'},
    {cityId: '20', city: 'Denizli', region: 'Ege'},
    {cityId: '21', city: 'Diyarbakır', region: 'Güneydoğu Anadolu'},
    {cityId: '81', city: 'Düzce', region: 'Karadeniz'},
    {cityId: '22', city: 'Edirne', region: 'Marmara'},
    {cityId: '23', city: 'Elazığ', region: 'Doğu Anadolu'},
    {cityId: '24', city: 'Erzincan', region: 'Doğu Anadolu'},
    {cityId: '25', city: 'Erzurum', region: 'Doğu Anadolu'},
    {cityId: '26', city: 'Eskişehir', region: 'İç Anadolu'},
    {cityId: '27', city: 'Gaziantep', region: 'Güneydoğu Anadolu'},
    {cityId: '28', city: 'Giresun', region: 'Karadeniz'},
    {cityId: '29', city: 'Gümüşhane', region: 'Karadeniz'},
    {cityId: '30', city: 'Hakkari', region: 'Doğu Anadolu'},
    {cityId: '31', city: 'Hatay', region: 'Akdeniz'},
    {cityId: '76', city: 'Iğdır', region: 'Doğu Anadolu'},
    {cityId: '32', city: 'Isparta', region: 'Akdeniz'},
    {cityId: '34', city: 'İstanbul (Anadolu)', region: 'Marmara'},
    {cityId: '35', city: 'İzmir', region: 'Ege'},
    {cityId: '46', city: 'Kahramanmaraş', region: 'Akdeniz'},
    {cityId: '78', city: 'Karabük', region: 'Karadeniz'},
    {cityId: '70', city: 'Karaman', region: 'İç Anadolu'},
    {cityId: '36', city: 'Kars', region: 'Doğu Anadolu'},
    {cityId: '37', city: 'Kastamonu', region: 'Karadeniz'},
    {cityId: '38', city: 'Kayseri', region: 'İç Anadolu'},
    {cityId: '71', city: 'Kırıkkale', region: 'İç Anadolu'},
    {cityId: '39', city: 'Kırklareli', region: 'Marmara'},
    {cityId: '40', city: 'Kırşehir', region: 'İç Anadolu'},
    {cityId: '79', city: 'Kilis', region: 'Güneydoğu Anadolu'},
    {cityId: '41', city: 'Kocaeli', region: 'Marmara'},
    {cityId: '42', city: 'Konya', region: 'İç Anadolu'},
    {cityId: '43', city: 'Kütahya', region: 'Ege'},
    {cityId: '44', city: 'Malatya', region: 'Doğu Anadolu'},
    {cityId: '45', city: 'Manisa', region: 'Ege'},
    {cityId: '47', city: 'Mardin', region: 'Güneydoğu Anadolu'},
    {cityId: '33', city: 'Mersin', region: 'Akdeniz'},
    {cityId: '48', city: 'Muğla', region: 'Ege'},
    {cityId: '49', city: 'Muş', region: 'Doğu Anadolu'},
    {cityId: '50', city: 'Nevşehir', region: 'İç Anadolu'},
    {cityId: '51', city: 'Niğde', region: 'İç Anadolu'},
    {cityId: '52', city: 'Ordu', region: 'Karadeniz'},
    {cityId: '80', city: 'Osmaniye', region: 'Akdeniz'},
    {cityId: '53', city: 'Rize', region: 'Karadeniz'},
    {cityId: '54', city: 'Sakarya', region: 'Marmara'},
    {cityId: '55', city: 'Samsun', region: 'Karadeniz'},
    {cityId: '56', city: 'Siirt', region: 'Güneydoğu Anadolu'},
    {cityId: '57', city: 'Sinop', region: 'Karadeniz'},
    {cityId: '58', city: 'Sivas', region: 'İç Anadolu'},
    {cityId: '63', city: 'Şanlıurfa', region: 'Güneydoğu Anadolu'},
    {cityId: '73', city: 'Şırnak', region: 'Doğu Anadolu'},
    {cityId: '59', city: 'Tekirdağ', region: 'Marmara'},
    {cityId: '60', city: 'Tokat', region: 'Karadeniz'},
    {cityId: '61', city: 'Trabzon', region: 'Karadeniz'},
    {cityId: '62', city: 'Tunceli', region: 'Doğu Anadolu'},
    {cityId: '64', city: 'Uşak', region: 'Ege'},
    {cityId: '65', city: 'Van', region: 'Doğu Anadolu'},
    {cityId: '77', city: 'Yalova', region: 'Marmara'},
    {cityId: '66', city: 'Yozgat', region: 'İç Anadolu'},
    {cityId: '67', city: 'Zonguldak', region: 'Karadeniz'},
]

export default locationCityList